// Email digest functions
import { API_BASE, isSignedIn } from './state.js';
import { showToast } from './utils.js';

export async function loadEmailStatus() {
  const toggle = document.getElementById('email-digest-toggle');
  const status = document.getElementById('email-status');
  const hint = document.getElementById('email-signin-hint');
  const prefsDiv = document.getElementById('email-preferences');
  
  try {
    const response = await fetch(API_BASE + '/email/status', { credentials: 'include' });
    const data = await response.json();
    
    if (toggle) toggle.checked = data.subscribed;
    if (status) {
      status.textContent = data.subscribed ? 'On' : 'Off';
      status.classList.toggle('active', data.subscribed);
    }
    if (prefsDiv) prefsDiv.style.display = data.subscribed ? 'block' : 'none';
    
    if (data.subscribed) {
      const emailDisplay = document.getElementById('email-address-display');
      if (emailDisplay) emailDisplay.textContent = data.email || '-';
      
      document.querySelectorAll('.freq-btn').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.freq === data.frequency);
      });
      document.querySelectorAll('.sched-btn').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.sched === data.schedule);
      });
      
      const categories = data.categories || ['world', 'tech', 'business'];
      document.querySelectorAll('#email-categories input').forEach(checkbox => {
        checkbox.checked = categories.includes(checkbox.value);
      });
      
      const nextDelivery = document.getElementById('next-delivery-time');
      if (nextDelivery && data.nextDelivery) nextDelivery.textContent = data.nextDelivery;
    }
    
    if (hint && !isSignedIn) {
      hint.style.display = 'block';
      if (toggle) toggle.disabled = true;
    }
  } catch (error) {
    console.error('Failed to load email status:', error);
  }
}

export async function toggleEmailDigest(enabled) {
  if (!isSignedIn) {
    showToast('Sign in to enable email digest', 'error');
    document.getElementById('email-digest-toggle').checked = false;
    return;
  }
  
  const status = document.getElementById('email-status');
  const prefsDiv = document.getElementById('email-preferences');
  
  try {
    if (enabled) {
      const email = window.googleUserEmail;
      if (!email) {
        showToast('Could not get email address', 'error');
        document.getElementById('email-digest-toggle').checked = false;
        return;
      }
      
      const response = await fetch(API_BASE + '/email/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, schedule: 'morning', categories: ['world', 'tech', 'business'], frequency: 'daily' })
      });
      
      if (!response.ok) throw new Error('Subscribe failed');
      
      showToast('Email digest enabled!');
      if (status) { status.textContent = 'On'; status.classList.add('active'); }
      if (prefsDiv) prefsDiv.style.display = 'block';
      loadEmailStatus();
    } else {
      const response = await fetch(API_BASE + '/email/unsubscribe', { method: 'POST', credentials: 'include' });
      if (!response.ok) throw new Error('Unsubscribe failed');
      
      showToast('Email digest disabled');
      if (status) { status.textContent = 'Off'; status.classList.remove('active'); }
      if (prefsDiv) prefsDiv.style.display = 'none';
    }
  } catch (error) {
    console.error('Email toggle error:', error);
    showToast('Failed to update email preference', 'error');
    document.getElementById('email-digest-toggle').checked = !enabled;
  }
}

export async function setEmailFrequency(frequency) {
  try {
    const response = await fetch(API_BASE + '/email/preferences', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ frequency })
    });
    if (!response.ok) throw new Error('Update failed');
    
    document.querySelectorAll('.freq-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.freq === frequency);
    });
    showToast('Frequency updated to ' + frequency);
    loadEmailStatus();
  } catch (error) {
    console.error('Frequency update error:', error);
    showToast('Failed to update frequency', 'error');
  }
}

export async function setEmailSchedule(schedule) {
  try {
    const response = await fetch(API_BASE + '/email/preferences', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ schedule })
    });
    if (!response.ok) throw new Error('Update failed');
    
    document.querySelectorAll('.sched-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.sched === schedule);
    });
    const labels = { morning: 'Morning (7 AM)', afternoon: 'Afternoon (12 PM)', evening: 'Evening (6 PM)' };
    showToast('Delivery time: ' + labels[schedule]);
    loadEmailStatus();
  } catch (error) {
    console.error('Schedule update error:', error);
    showToast('Failed to update schedule', 'error');
  }
}

export async function updateEmailCategories() {
  const checkboxes = document.querySelectorAll('#email-categories input:checked');
  const categories = Array.from(checkboxes).map(cb => cb.value);
  
  if (categories.length === 0) { showToast('Select at least one topic', 'error'); return; }
  
  try {
    const response = await fetch(API_BASE + '/email/preferences', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ categories })
    });
    if (!response.ok) throw new Error('Update failed');
    showToast('Topics updated');
  } catch (error) {
    console.error('Categories update error:', error);
    showToast('Failed to update topics', 'error');
  }
}

export async function sendTestEmail() {
  const btn = document.querySelector('.test-email-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
  
  try {
    const response = await fetch(API_BASE + '/email/test', { method: 'POST', credentials: 'include' });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Send failed');
    showToast('Test email sent! Check your inbox.');
  } catch (error) {
    console.error('Test email error:', error);
    showToast('Failed to send test email: ' + error.message, 'error');
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = '📤 Send test email'; }
  }
}
